/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceInstallationApiFrom } from '../../models/device-installation-api-from';

export interface ApiV3ServiceDeviceidPost$Params {

/**
 * Request language.
 */
  lang?: string;
  
    /**
     * Data for device registration in Azure
     */
    body?: DeviceInstallationApiFrom
}

export function apiV3ServiceDeviceidPost(http: HttpClient, rootUrl: string, params?: ApiV3ServiceDeviceidPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceDeviceidPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV3ServiceDeviceidPost.PATH = '/api/v3/service/deviceid';
